import { useTranslation } from 'appState';
import { fillTranslationTextWithVariables } from 'hooks';
import { AssessmentResults } from 'types';

type CognitiveStrength = {
  id: 'memory' | 'adaptability' | 'attention' | 'problemSolving' | 'speed' | 'persistence';
  score: number;
  name: string;
}

type SegmentationFeedbackProps = {
  username: string;
  results?: AssessmentResults | null;
  cognitiveStrengths?: CognitiveStrength[] | null;
}

const SegmentationFeedback: React.FC<SegmentationFeedbackProps> = ({
  username,
  results,
  cognitiveStrengths
}) => {
  const lang = useTranslation('GamesCompleted');
  return (
    <>
      {results?.isEnt === undefined ? <>{lang.message}</> :
        (<>
          {
            fillTranslationTextWithVariables(
              results?.isEnt ? lang.messageEnt : lang.messageWage, { username }
            )
          }
          {cognitiveStrengths && cognitiveStrengths.length > 0 &&
            <>
              {
                fillTranslationTextWithVariables(
                  results?.isEnt ? lang.messageEntSkills : lang.messageWageSkills, {
                    skill1: cognitiveStrengths[0]?.name ?? '',
                    skill2: cognitiveStrengths[1]?.name ?? '',
                    skill3: cognitiveStrengths[2]?.name ?? ''
                  })
              }
            </>
          }
        </>)
      }
    </>
  );
};

export default SegmentationFeedback;
